import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'
import constant from '@constants/constant'
import messageProcessor from './messageProcessor'
import {
  HubConnectionBuilder,
  HttpTransportType,
  LogLevel,
} from '@aspnet/signalr'

let connection = {}

let config = {}

export default {
  install(Vue, options) {
    console.log('options received', options)

    Vue.prototype.$startBroadcastConnection = startBroadcastConnection
    Vue.prototype.$stopBroadcastConnection = stopBroadcastConnection

    config.enableBroadcast = Boolean(parseInt(options.enableBroadcast || '0'))

    if (config.enableBroadcast) {
      let isValidEndpoint =
        appConfig.broadcastRESTAPIEndpoint && appConfig.broadcastHubEndpoint
      if (!isValidEndpoint) {
        config.enableBroadcast = false
        console.error('Missing Required Broadcast Endpoint Configurations.')
      }
    }

    // todelete
    console.log('Broadcast Enabled state: ', config.enableBroadcast)

    if (!config.enableBroadcast) return

    console.log('Installing BROADCAST Module')
    connection = new HubConnectionBuilder()
      .withUrl(appConfig.broadcastHubEndpoint, {
        transport: HttpTransportType.WebSockets,
      })
      .configureLogging(LogLevel.Information)
      .build()

    connection.on('SendHubMessage', (bMsg) => {
      let message = JSON.parse(bMsg)

      // todelete
      console.log('Received notification from hub', message)

      let successCode = constant.hmdaNotificationStatus.success

      let parsed = messageProcessor.parseMessage(message)
      if (parsed.messageType !== messageProcessor.messageType.None) {
        __showAlert(
          parsed.message.displayText,
          parsed.message.OrderStatus === successCode ||
            parsed.message.RuleEngineStatus.Status === successCode
        )
      }

      store.dispatch('broadcast/setMessage', parsed, { root: true })
    })
    connection.onclose(function() {
      console.log('connection closed')
      config.connectionId = null
    })
  },
}

export const state = {
  messageTypeRuleEngine: {},
  messageTypeFileUpload: {},
  messages: [],
  filesUploadedList: [],
  connectionId: null,
}

export const getters = {
  messageTypeRuleEngine: (state) => state.messageTypeRuleEngine,
  messageTypeFileUpload: (state) => state.messageTypeFileUpload,
  broadcastMessages: (state) => state.messages,
}

export const mutations = {
  SET_MESSAGE(state, parsedMessage) {
    if (parsedMessage.messageType === messageProcessor.messageType.RuleEngine) {
      state.messageTypeRuleEngine = parsedMessage.message
    } else {
      state.messageTypeFileUpload = parsedMessage.message
    }
  },

  SET_NOTIFICATIONS(state, value) {
    state.messages = value
  },

  ADD_NOTIFICATION(state, value) {
    if (!state.messages) state.messages = []
    state.messages.push(value)
  },

  REMOVE_NOTIFICATION(state, id) {
    if (state.messages) {
      let n = state.messages.indexOf((i) => i.id === id)
      state.messages = state.messages.splice(n, 1)
    }
  },
}

export const actions = {
  setMessage({ commit }, parsed) {
    commit('SET_MESSAGE', parsed)
  },
  addNotification({ commit }, value) {
    commit('ADD_NOTIFICATION', value)
  },
  setNotifications({ commit }, value) {
    commit('SET_NOTIFICATIONS', value)
  },
  removeNotification({ commit }) {
    commit('REMOVE_NOTIFICATION')
  },
}

function STOP() {
  try {
    connection.stop()
    console.log('connecition closed')
  } catch (e) {}
}

function stopBroadcastConnection() {
  STOP()
}

function startBroadcastConnection() {
  console.log('Attempting to start connection')
  if (!config.enableBroadcast) {
    console.log('Broadcast is Disabled. Returning')
    return
  }

  if (store.state.auth.currentUser) {
    console.log('user has token')
    if (!config.connectionId) {
      console.log('no connection id, starting new one START()')
      START()
    } else {
      console.log(
        'there is already a connection, not starting',
        config.connectionId
      )
    }
  } else {
    console.log('user is not logged in, not starting connection')
  }
}

function registerConnectionId(conId) {
  let user = store.state.auth.currentUser
  console.log(
    'i am going to register this subscription to hub, am I Logged in?',
    user
  )

  if (!user) return

  axios
    .post(
      `${appConfig.broadcastRESTAPIEndpoint}${endpoint.broadcast.saveConnection}/${conId}`,
      null,
      {
        headers: setHeaders(),
        validateStatus: (status) => status === 200,
      }
    )
    .then((res) => {
      console.log(res)
      console.log(
        'wss connection id registered, saving connectionid to vuex state'
      )
      config.connectionId = conId
    })
    .catch((err) => {
      STOP()
      __showError(err)
    })
}

function parseConnectionId(szUrl = '') {
  return szUrl.substring(szUrl.indexOf('id=') + 3, szUrl.length)
}

function START() {
  console.log('starting broadcast connection')
  console.log(
    'connection state ',
    connection.connection ? connection.connection.connectionState : 'null'
  )
  if (connection.connection && connection.connection.connectionState !== 0) {
    connection
      .start()
      .then(() => {
        registerConnectionId(
          parseConnectionId(connection.connection.transport.webSocket.url)
        )
        console.log('connectino success', connection)
      })
      .catch((err) => {
        // debugger
        console.error('Failed to connect with hub', err)
        return new Promise((resolve) => resolve())
      })
  }
}

function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}

function __showAlert(msg, isSuccess = true) {
  return isSuccess ? __showSuccess(msg) : __showError(msg)
}

function __showError(msg) {
  store.dispatch(
    'toaster/setAlert',
    {
      title: 'Error',
      msg: msg || 'An unexpected error occured while processing data (0x33)',
      variant: constant.AlertTypes.Error,
    },
    { root: true }
  )
}

function __showSuccess(msg) {
  store.dispatch(
    'toaster/setAlert',
    {
      title: 'Success',
      msg: msg,
      variant: constant.AlertTypes.Success,
    },
    { root: true }
  )
}
